/**
 * @deprecated Invoice create preferences are persisted on the backend only.
 *
 * Former browser key: `invoice.lastTemplate.{empId}.{clientIdOrName}`
 *
 * Use `invoiceConfigService.getClientTemplatePreference()` /
 * `invoiceConfigService.persistClientInvoicePreferences()` instead.
 * Client template assignment via `getTemplateForClient()` is the load path.
 *
 * Draft autosave uses `invoiceDraftService` (API + session fallback) — not this module.
 */

const KEY_PREFIX = 'invoice.lastTemplate.'

/** Remove retired per-client preference keys so they cannot be read again. */
export function purgeLegacyTemplatePreferenceKeys() {
  if (typeof localStorage === 'undefined') return
  try {
    const toRemove = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(KEY_PREFIX)) toRemove.push(key)
    }
    toRemove.forEach((key) => localStorage.removeItem(key))
  } catch {
    /* private mode / quota — ignore */
  }
}

// Purge on module load (same pattern as invoice-template-local-store.js).
purgeLegacyTemplatePreferenceKeys()

/** @deprecated No-op — preferences load from backend only. */
export function getLastTemplatePreference(/* clientIdOrName */) {
  return null
}

/** @deprecated No-op — use invoiceConfigService.persistClientInvoicePreferences(). */
export function setLastTemplatePreference(/* clientIdOrName, preference */) {
  /* intentionally empty */
}

/** @deprecated No-op — use invoiceConfigService.clearClientTemplatePreference(). */
export function clearLastTemplatePreference(/* clientIdOrName */) {
  /* intentionally empty */
}
